export const htmxExcludedWidgets = [
  "SearchPage",
  "CategoryPage",
  "SearchHeader",
  "SearchResult",
  "FilterChips",
  "Facets",
  "FacetBarWheels",
  "FacetBarTires",
  "VehicleSpecs",
  "RelatedItems",
  "BoughtTogether"
];
